import _ from 'lodash';
import React from 'react';

import {fetchBookingOptionsForNotesList as sdkFetchBookings} from 'sdk/notes';

import Button from 'components/Button';
import SelectFilter from 'components/Filters/SelectFilter';
import DateRangeFilter from 'components/Filters/DateRangeFilter';
import ToggleSelectFilter from 'components/Filters/ToggleSelectFilter';
import BookingFilter from 'components/Filters/BookingFilter';

import {BOOKING_TYPE, ROOM_TYPE, SALES_TYPE} from 'ducks/notes';

import './styles.css';

const RESOLVED_STATUS = 'Resolved';
const UNRESOLVED_STATUS = 'Unresolved';
const REQUIRES_ACTION = 'Requires Action';
const INFORMATIVE = 'Informative';

const noteCategoryData = [
  {label: 'Requires Action', value: REQUIRES_ACTION},
  {label: 'Informative', value: INFORMATIVE}
];

const noteTypeData = [
  {label: 'Booking', value: BOOKING_TYPE},
  {label: 'Room', value: ROOM_TYPE},
  {label: 'Sales', value: SALES_TYPE}
];

const noteStatusData = [
  {label: 'Unresolved', value: UNRESOLVED_STATUS},
  {label: 'Resolved', value: RESOLVED_STATUS}
];

interface PassedProps {
  filters: any;
  setFilter: (field: string, value: any) => void;
  clearFilters: () => void;
  rooms: any;
  locationRef: string;
}

class NotesListFilters extends React.Component<PassedProps> {
  bookingSelectElement: any = null;

  fetchBookingOptions = search => {
    const {locationRef} = this.props;

    return sdkFetchBookings({locationRef, search});
  };

  clearFilters = () => {
    if (this.bookingSelectElement) {
      this.bookingSelectElement.onChange(null);
    }

    this.props.clearFilters();
  };

  render() {
    const {setFilter, rooms, filters} = this.props;

    const roomsData = rooms.map(room => ({
      label: room.roomNumber,
      value: room.id
    }));

    return (
      <div className="NotesListFilters colab-row-space-between">
        <div className="colab-sidepadding-2">
          <BookingFilter
            fetchSdk={this.fetchBookingOptions}
            bookingSelectRef={el => (this.bookingSelectElement = el)}
            onChange={this.props.setFilter}
            value={filters.booking}
          />
          <SelectFilter
            label="Room Number"
            classNameForTesting="roomNumber"
            data={roomsData}
            value={filters.rooms}
            onChange={rooms => setFilter('rooms', rooms)}
          />
          <ToggleSelectFilter
            label="Notes Category"
            classNameForTesting="notesCategory"
            value={filters.noteCategory}
            data={noteCategoryData}
            onChange={noteCategory => setFilter('noteCategory', noteCategory)}
          />
          <ToggleSelectFilter
            label="Note Type"
            classNameForTesting="noteType"
            value={filters.noteType}
            data={noteTypeData}
            onChange={noteType => setFilter('noteType', noteType)}
          />
          <ToggleSelectFilter
            label="Note Status"
            classNameForTesting="noteStatus"
            value={filters.status}
            data={noteStatusData}
            onChange={status => setFilter('status', status)}
          />
          <DateRangeFilter
            label="Created"
            fieldName="createdAt"
            classNameForTesting="createdAt"
            start={filters.createdAtStart}
            end={filters.createdAtEnd}
            onChange={(dateField, date) => setFilter(dateField, date)}
          />
          <DateRangeFilter
            label="Resolved"
            fieldName="resolvedAt"
            classNameForTesting="resolvedAt"
            start={filters.resolvedAtStart}
            end={filters.resolvedAtEnd}
            onChange={(dateField, date) => setFilter(dateField, date)}
          />
        </div>
        <div>
          <Button clear onClick={this.clearFilters}>
            Clear all filters
          </Button>
        </div>
      </div>
    );
  }
}

export default NotesListFilters;
